export const CHANGE_REGION_AREA = 'CHANGE_REGION_AREA';
export const CHANGE_COORD_AREA = 'CHANGE_COORD';

export function changeRegionAction(value) {
    return {
        type: CHANGE_REGION_AREA,
        value: value
    };
}

export function changeCoordAction(coord) {
    return {
        type: CHANGE_COORD_AREA,
        coord: coord
    };
}